import { UrlMatchResult, UrlSegment } from '@angular/router';

export function sisCategoryMatcher(segment: UrlSegment[]): UrlMatchResult {
  const match = (
    segment.length > 2 &&
    (segment[0].path === 'accessory' || segment[1].path === 'accessory') &&
    segment[segment.length - 2].path === 'csc' &&
    segment[segment.length - 1].path.length > 0
  );

  return match ? {
    consumed: segment,
    posParams: {
      categoryCode: segment[segment.length - 1]
    }
  } : null;
}
